import useI18n from '../../../i18n/useI18n'
import general from '../../../utils/general'
import './HeroSection.scss'

const HeroSection = ({ university, onApplyClick }) => {
  const { t, language } = useI18n()
  if (!university) return null
  console.log(university)
  return (
    <div className="university-hero-section">
      <div
        className="hero-background"
        style={{
          backgroundImage: university.coverImageUrl
            ? `url(${university.coverImageUrl})`
            : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-logo">
            {university.logoUrl ? (
              <img
                src={university.logoUrl}
                alt={general.getLocaleValue(university, 'name', language)}
                onError={(e) => {
                  e.target.style.display = 'none'
                  e.target.nextSibling.style.display = 'flex'
                }}
              />
            ) : null}
            <div className="hero-logo-placeholder" style={{ display: university.logoUrl ? 'none' : 'flex' }}>
              <i className="zmdi zmdi-city"></i>
            </div>
          </div>
          <div className="hero-title">
            <h1>{general.getLocaleValue(university, 'name', language)}</h1>
            <p className="hero-subtitle">
              {university.subtitle || t('UNIVERSITY_HERO_SUBTITLE_FOREIGN_STUDENTS')}
            </p>
          </div>
          <button
            className="btn btn-primary btn-hero-apply"
            onClick={onApplyClick}
          >
            <span>{t('UNIVERSITY_HERO_APPLY_NOW')}</span>
            <i className="zmdi zmdi-mail-send"></i>
          </button>
        </div>
      </div>
      <div className="hero-wave-separator">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M0,0 C300,120 600,0 900,60 C1050,90 1125,60 1200,60 L1200,120 L0,120 Z" fill="currentColor"></path>
        </svg>
      </div>
    </div>
  )
}

export default HeroSection

